// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ScheduleIntervalDetailsFragmentDoc } from '../../../projects/schedule-v2/table/DateCell.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PhaseTaskListPaneQueryVariables = Types.Exact<{
  phaseId: Types.Scalars['ID']['input'];
  stale?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type PhaseTaskListPaneQuery = { __typename?: 'Query', scheduleTasks: Array<{ __typename?: 'ScheduleTask', id: string, name: string, scheduleSubPhase?: { __typename?: 'ScheduleSubPhase', id: string } | null | undefined, statusDetail: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string }, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number }, scheduleFlags: Array<{ __typename?: 'ScheduleFlag', id: string, reason?: { __typename?: 'ScheduleFlagReason', id: string, title: string } | null | undefined }> }> };

export type PhaseTaskListPaneScheduleTaskDetailFragment = { __typename?: 'ScheduleTask', id: string, name: string, scheduleSubPhase?: { __typename?: 'ScheduleSubPhase', id: string } | null | undefined, statusDetail: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string }, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number }, scheduleFlags: Array<{ __typename?: 'ScheduleFlag', id: string, reason?: { __typename?: 'ScheduleFlagReason', id: string, title: string } | null | undefined }> };

export const PhaseTaskListPaneScheduleTaskDetailFragmentDoc = gql`
    fragment PhaseTaskListPaneScheduleTaskDetail on ScheduleTask {
  id
  name
  scheduleSubPhase {
    id
  }
  statusDetail {
    code
    name
  }
  interval {
    ...ScheduleIntervalDetails
  }
  scheduleFlags {
    id
    reason {
      id
      title
    }
  }
}
    ${ScheduleIntervalDetailsFragmentDoc}`;
export const PhaseTaskListPaneDocument = gql`
    query PhaseTaskListPane($phaseId: ID!, $stale: Boolean) {
  scheduleTasks(
    filter: {schedulePhase: [$phaseId], status: [NOT_STARTED, COMPLETE, DELAYED, IN_PROGRESS, ON_HOLD], stale: $stale}
  ) {
    ...PhaseTaskListPaneScheduleTaskDetail
  }
}
    ${PhaseTaskListPaneScheduleTaskDetailFragmentDoc}`;

/**
 * __usePhaseTaskListPaneQuery__
 *
 * To run a query within a React component, call `usePhaseTaskListPaneQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhaseTaskListPaneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhaseTaskListPaneQuery({
 *   variables: {
 *      phaseId: // value for 'phaseId'
 *      stale: // value for 'stale'
 *   },
 * });
 */
export function usePhaseTaskListPaneQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PhaseTaskListPaneQuery, PhaseTaskListPaneQueryVariables> & ({ variables: PhaseTaskListPaneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PhaseTaskListPaneQuery, PhaseTaskListPaneQueryVariables>(PhaseTaskListPaneDocument, options);
      }
export function usePhaseTaskListPaneLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PhaseTaskListPaneQuery, PhaseTaskListPaneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PhaseTaskListPaneQuery, PhaseTaskListPaneQueryVariables>(PhaseTaskListPaneDocument, options);
        }
// @ts-ignore
export function usePhaseTaskListPaneSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PhaseTaskListPaneQuery, PhaseTaskListPaneQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PhaseTaskListPaneQuery, PhaseTaskListPaneQueryVariables>;
export function usePhaseTaskListPaneSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PhaseTaskListPaneQuery, PhaseTaskListPaneQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PhaseTaskListPaneQuery | undefined, PhaseTaskListPaneQueryVariables>;
export function usePhaseTaskListPaneSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PhaseTaskListPaneQuery, PhaseTaskListPaneQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PhaseTaskListPaneQuery, PhaseTaskListPaneQueryVariables>(PhaseTaskListPaneDocument, options);
        }
export type PhaseTaskListPaneQueryHookResult = ReturnType<typeof usePhaseTaskListPaneQuery>;
export type PhaseTaskListPaneLazyQueryHookResult = ReturnType<typeof usePhaseTaskListPaneLazyQuery>;
export type PhaseTaskListPaneSuspenseQueryHookResult = ReturnType<typeof usePhaseTaskListPaneSuspenseQuery>;
export type PhaseTaskListPaneQueryResult = Apollo.QueryResult<PhaseTaskListPaneQuery, PhaseTaskListPaneQueryVariables>;